import { ThumbType } from '~/shared/api'
import { PhotoConfig } from '~/shared/ui/form/PickPhotos/PickPhotos'

export const getNextPhotoConfig = (
  photos: ThumbType[],
  photoConfig?: PhotoConfig[],
) => {
  if (!photoConfig?.length) return null

  const usedTypes = photos.map((p) => p.type)
  const next = photoConfig.find((c) => !usedTypes.includes(c.type))

  if (!next) return null

  return {
    type: next.type,
    title: next.title,
  }
}
